const { String } = require('core-js');
const FileSaver = require('file-saver');
const XLSX = require('sheetjs-style');
const { default: SystemService } = require('../api/SystemService');

module.exports = {
    ArabicNumberToText(Number) {
        var Number = CheckNumber(Number);
        var NumberArray = new Array ("ศูนย์", "หนึ่ง", "สอง", "สาม", "สี่", "ห้า", "หก", "เจ็ด", "แปด", "เก้า", "สิบ");
        var DigitArray = new Array ("", "สิบ", "ร้อย", "พัน", "หมื่น", "แสน", "ล้าน");
        var BahtText = "";
        if (isNaN(Number))
        {
            return "ข้อมูลนำเข้าไม่ถูกต้อง";
        } else
        {
            if ((Number - 0) > 9999999.9999)
            {
                return "ข้อมูลนำเข้าเกินขอบเขตที่ตั้งไว้";
            } else
            {
                Number = Number.split (".");
                if (Number[1]) {
                    Number[1] = Number[1].padEnd(2, '0').substring(0, 2);
                } else {
                    Number[1] = "00";
                }
                var NumberLen = Number[0].length - 0;
                for(var i = 0; i < NumberLen; i++)
                {
                    var tmp = Number[0].substring(i, i + 1) - 0;
                    if (tmp != 0)
                    {
                        if ((i == (NumberLen - 1)) && (tmp == 1))
                        {
                            BahtText += "เอ็ด";
                        } else
                        if ((i == (NumberLen - 2)) && (tmp == 2))
                        {
                            BahtText += "ยี่";
                        } else
                        if ((i == (NumberLen - 2)) && (tmp == 1))
                        {
                            BahtText += "";
                        } else
                        {
                            BahtText += NumberArray[tmp];
                        }
                        BahtText += DigitArray[NumberLen - i - 1];
                    }
                }
                BahtText += "บาท";
                if ((Number[1] == "0") || (Number[1] == "00"))
                {
                    BahtText += "ถ้วน";
                } else
                {
                    DecimalLen = Number[1].length - 0;
                    for (var i = 0; i < DecimalLen; i++)
                    {
                        var tmp = Number[1].substring(i, i + 1) - 0;
                        if (tmp != 0)
                        {
                            if ((i == (DecimalLen - 1)) && (tmp == 1))
                            {
                                BahtText += "เอ็ด";
                            } else
                            if ((i == (DecimalLen - 2)) && (tmp == 2))
                            {
                                BahtText += "ยี่";
                            } else
                            if ((i == (DecimalLen - 2)) && (tmp == 1))
                            {
                                BahtText += "";
                            } else
                            {
                                BahtText += NumberArray[tmp];
                            }
                            BahtText += DigitArray[DecimalLen - i - 1];
                        }
                    }
                    BahtText += "สตางค์";
                }
                return BahtText;
            }
        }
    },
    exportCSVFile(headers, items, fileTitle) {
        if (headers) {
            items.unshift(headers);
        }
    
        // Convert Object to JSON
        var jsonObject = JSON.stringify(items);
    
        var csv = convertToCSV(jsonObject);
    
        var exportedFilenmae = fileTitle + '.xlsx' || 'export.xlsx';
    
        var blob = new Blob([csv], { type: 'text/xlsx;charset=utf-8;' });
        if (navigator.msSaveBlob) { // IE 10+
            navigator.msSaveBlob(blob, exportedFilenmae);
        } else {
            var link = document.createElement("a");
            if (link.download !== undefined) { // feature detection
                // Browsers that support HTML5 download attribute
                var url = URL.createObjectURL(blob);
                link.setAttribute("href", url);
                link.setAttribute("download", exportedFilenmae);
                link.style.visibility = 'hidden';
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            }
        }
    },
    exportXLSXFile(headers, json, fileName, fields) {
        const list = [...json].map(item => {
            if (fields) {
                const obj = {};
                fields.forEach(field => {
                    obj[field] = item[field];
                });
                return obj;
            } else {
                return item;
            }
        });

        if (headers) {
            list.unshift(headers);
        }

        const data = list;
        // console.log(list);
        const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
        const fileExtension = '.xlsx';
        const ws = XLSX.utils.json_to_sheet(data);
        const all_width = []
        for (var key in headers) {
            all_width.push({ wpx: 200 })
        }
        ws['!cols'] = all_width;
        const wb = { Sheets: { 'data': ws }, SheetNames: ['data'] };
        const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
        const data1 = new Blob([excelBuffer], {type: fileType});
        FileSaver.saveAs(data1, fileName + fileExtension);
    },
    xlxsBase64toJson(base64) {
        const cleanBase64 = base64.replace(/\s/g, '');
        const workbook = XLSX.read(cleanBase64, { type: 'base64' });
        const sheet = workbook.Sheets[workbook.SheetNames[0]];
        const json = XLSX.utils.sheet_to_json(sheet);
        // json.shift();

        return json;
    },
    validatePhoneNo(_rule, value) {
        const patternFixed = /^[0-9]+$/;
        const specialCharPattern = /[!@#$%^&*(),.?":{}|<>_\-+=/\\[\]~`]/;
        if (!value && _rule?.required == null) {
            return Promise.resolve();
        }
        if(!value && _rule?.required != null){
            return Promise.reject('กรุณากรอกเบอร์โทร');
        }
        if(specialCharPattern.test(value)){
            return Promise.reject('กรุณากรอกหมายเลขโทรศัพท์ให้ถูกต้อง (10 หลัก และมีเฉพาะตัวเลขเท่านั้น)');
        }
        if (!patternFixed.test(value)) {
            return Promise.reject('กรุณากรอกเฉพาะตัวเลขเท่านั้น');
        }
        if (value.length < 10 || value.length > 10) {
            return Promise.reject('หมายเลขโทรศัพท์ต้องมี 10 หลัก');
        }
        return Promise.resolve()
    },
    validateLatLng(_rule, value) {
        if (!value) {
            return Promise.resolve();
        }

        // Split by comma
        const parts = value.split(',');
        if (parts.length !== 2) {
        return Promise.reject(
            new Error('รูปแบบพิกัดไม่ถูกต้อง lat, lng (ตัวอย่าง: 13.756331, 100.501762)')
        );
        }

        const lat = parseFloat(parts[0]);
        const lng = parseFloat(parts[1]);

        if (isNaN(lat) || isNaN(lng) || !/^[-+]?\d+(\.\d+)?$/.test(parts[0]) || !/^[-+]?\d+(\.\d+)?$/.test(parts[1]) ) {
            return Promise.reject(
                new Error('ค่าพิกัดต้องเป็นตัวเลข lat, lng (ตัวอย่าง: 13.756331, 100.501762)')
            );
        }

        // Check valid ranges
        if (lat < -90 || lat > 90) {
        return Promise.reject(new Error('Latitude ต้องอยู่ระหว่าง -90 ถึง 90'));
        }
        if (lng < -180 || lng > 180) {
        return Promise.reject(new Error('Longitude ต้องอยู่ระหว่าง -180 ถึง 180'));
        }

        return Promise.resolve();
    },
    validateFaxNo(_rule, value) {
        const patternFixed = /^[0-9]+$/;
        const specialCharPattern = /[!@#$%^&*(),.?":{}|<>_\-+=/\\[\]~`]/;
        if (!value) {
            return Promise.resolve();
        }
        if(specialCharPattern.test(value)){
            return Promise.reject('กรุณากรอกเบอร์แฟกซ์ให้ถูกต้อง (10 หลัก และมีเฉพาะตัวเลขเท่านั้น)');
        }
        if (!patternFixed.test(value)) {
            return Promise.reject('กรุณากรอกเฉพาะตัวเลขเท่านั้น');
        }
        if (value.length < 9 || value.length > 9) {
            return Promise.reject('เบอร์แฟกซ์ต้องมี 9 หลัก');
        }
        return Promise.resolve()
    },
    validateNumber(_rule, value) {
        const patternFixed = /^[0-9]+$/;
        const specialCharPattern = /[!@#$%^&*(),.?":{}|<>_\-+=/\\[\]~`]/;
        if (!value && _rule?.required == null) {
            return Promise.resolve();
        }
        if(specialCharPattern.test(value)){
            return Promise.reject('มีอักขระที่ไม่อนุญาต กรุณาตรวจสอบ');
        }
        if (!patternFixed.test(value)) {
            return Promise.reject('กรุณากรอกเฉพาะตัวเลขเท่านั้น');
        }
        return Promise.resolve()
    },
    async validateCardId(_rule, value) {
        const currentValue = value;
        const patternFixed = /^[0-9]+$/;
        if (!value || value === this.old_id_no) {
            return Promise.resolve();
        }
        if (!patternFixed.test(value)) {
            return Promise.reject('กรุณากรอกเฉพาะตัวเลขเท่านั้น');
        }
        if (value.length < 13 || value.length > 13) {
            return Promise.reject('เลขบัตรประชาชนต้องมี 13 หลัก');
        }
        try {
            const res = await SystemService.check_duplicate(
                this.model_type,
                `field=${_rule.field}&value=${value}&id=${this.action_type}`
            );

            if (this.model_form.id_no !== currentValue) {
                return new Promise(() => {});
            }

            if (res) {
                return Promise.reject("เลขบัตรประชาชนนี้มีอยู่ในระบบแล้ว");
            }
        } catch (error) {
            return Promise.reject("เกิดข้อผิดพลาดในการตรวจสอบข้อมูลซ้ำ");
        }
    },
    async validateBarcode(_rule, value) {
        const currentValue = value;
        const specialCharPattern = /[!@#$%^&*(),.?":{}|<>_\-+=/\\[\]~`]/;
        if (value == this.old_barcode) {
            return Promise.resolve();
        }
        if(!value){
            return Promise.reject('กรุณากรอกรหัส');
        }
        if (/\s/.test(value)) {
            return Promise.reject('รหัสห้ามมีเว้นวรรค');
        }
        if (specialCharPattern.test(value)) {
            return Promise.reject('กรุณากรอกรหัสให้ถูกต้อง (รหัสต้องประกอบด้วยตัวอักษรและตัวเลขเท่านั้น)');
        }
        if (value.length > 20) {
            return Promise.reject('รหัสต้องมี 20 หลัก');
        }
        try {
            const res = await SystemService.check_duplicate(
                this.model_type,
                `field=${_rule.field}&value=${value}&id=${this.action_type}`
            );

            if (this.model_form.barcode !== currentValue) {
                return new Promise(() => {});
            }

            if (res) {
                return Promise.reject("รหัสนี้มีอยู่ในระบบแล้ว");
            }
        } catch (error) {
            return Promise.reject("เกิดข้อผิดพลาดในการตรวจสอบข้อมูลซ้ำ");
        }
    },
    async validateUserNo(_rule, value) {
        const currentValue = value;
        const patternFixed = /^[0-9]+$/;
        const specialCharPattern = /[!@#$%^&*(),.?":{}|<>_\-+=/\\[\]~`]/;
        if (!value || value == this.old_employee_no) {
            return Promise.resolve();
        }
        // if (specialCharPattern.test(value)) {
        //     return Promise.reject('มีอักขระที่ไม่อนุญาต กรุณาตรวจสอบ');
        // }
        // if (!patternFixed.test(value)) {
        //     return Promise.reject('กรุณากรอกเฉพาะตัวเลขเท่านั้น');
        // }
        try {
            const res = await SystemService.check_duplicate(
                this.model_type,
                `field=${_rule.field}&value=${value}&id=${this.action_type}`
            );

            if (this.model_form.employee_no !== currentValue) {
                return new Promise(() => {});
            }

            if (res) {
                return Promise.reject("เลขบัตรประจำตัวพนักงานนี้มีอยู่ในระบบแล้ว");
            }
        } catch (error) {
            return Promise.reject("เกิดข้อผิดพลาดในการตรวจสอบข้อมูลซ้ำ");
        }
    },
    async validateEmail(_rule, value) {
        const currentValue = value;
        const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        const emailSpecialPattern = /^[a-zA-Z0-9_.-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        if (value == this.old_email || (!value && _rule?.required == null)) {
            return Promise.resolve();
        }
        if(!value && _rule?.required == true){
            return Promise.reject('กรุณากรอกอีเมล');
        }
        if (!emailPattern.test(value)) {
            return Promise.reject('โปรดตรวจสอบรูปแบบอีเมลอีกครั้ง');
        }
        if (!emailSpecialPattern.test(value)) {
            return Promise.reject('อีเมลมีอักขระที่ไม่อนุญาต (มีการใช้สัญลักษณ์พิเศษนอกเหนือจาก ., _, -)');
        }
        if (value.length > 100) {
            return Promise.reject("อีเมลต้องไม่เกิน 100 ตัวอักษร");
        }

        // Only call duplicate check if `this.create` is true
        try {
            const res = await SystemService.check_duplicate(
                this.model_type,
                `field=${_rule.field}&value=${value}&id=${this.action_type}`
            );

            if (this.model_form.email !== currentValue) {
                return new Promise(() => {});
            }

            if (res) {
                return Promise.reject("อีเมลนี้ถูกใช้ลงทะเบียนแล้ว");
            }
        } catch (error) {
            return Promise.reject("เกิดข้อผิดพลาดในการตรวจสอบข้อมูลซ้ำ");
        }

        return Promise.resolve();
    },
    async validatePart(_rule, value) {
        const currentValue = value;
        const specialPattern = /[!@#$%^&*(),?":{}|<>\+=/\\[\]~`]/;
        const patternFixed = /^[0-9]+$/;
        if (value == this.old_part_type) {
            return Promise.resolve();
        }
        if(!value && _rule?.required == true){
            return Promise.reject('กรุณากรอกชื่ออะไหล่');
        }
        if(patternFixed.test()){
            return Promise.reject('โปรดตรวจสอบรูปแบบชื่ออะไหล่อีกครั้ง');
        }
        if (specialPattern.test(value)) {
            return Promise.reject('ชื่ออะไหล่มีอักขระที่ไม่อนุญาต (มีการใช้สัญลักษณ์พิเศษนอกเหนือจาก ., _, -)');
        }
        if (value.length > 100) {
            return Promise.reject("ชื่ออะไหล่ต้องไม่เกิน 100 ตัวอักษร");
        }

        // Only call duplicate check if `this.create` is true
        try {
            const res = await SystemService.check_duplicate(
                this.model_type,
                `field=${_rule.field}&value=${value}&id=${this.action_type}`
            );

            if (this.model_form.name !== currentValue) {
                return new Promise(() => {});
            }

            if (res) {
                return Promise.reject("ชื่ออะไหล่นี้ถูกใช้แล้ว");
            }
        } catch (error) {
            return Promise.reject("เกิดข้อผิดพลาดในการตรวจสอบข้อมูลซ้ำ");
        }

        return Promise.resolve();
    },
    async validatePartType(_rule, value) {
        const currentValue = value;
        const patternFixed = /^[0-9]+$/;
        const specialCharPattern = /[!@#$%^&*(),.?":{}|<>_\-+=/\\[\]~`]/;
        const wording = this.model_type == 'PartType' ? "ชื่อประเภทอะไหล่" : "ชื่อหน่วยอะไหล่"
        if (value == this.old_part) {
            return Promise.resolve();
        }
        if(!value){
            return Promise.reject('กรุณากรอก'+ wording)
        }
        if (specialCharPattern.test(value) || patternFixed.test(value)) {
            return Promise.reject( wording + 'ต้องเป็นตัวอักษรเท่านั้น');
        }
        if (value.length > 50 && this.model_type == 'PartType') {
            return Promise.reject('ชื่อประเภทอะไหล่ต้องไม่เกิน 50 ตัวอักษร');
        }
        if (value.length > 30 && this.model_type == 'PartUnit') {
            return Promise.reject('ชื่อประเภทอะไหล่ต้องไม่เกิน 30 ตัวอักษร');
        }
        try {
            const res = await SystemService.check_duplicate(
                this.model_type,
                `field=${_rule.field}&value=${value}&id=${this.action_type}`
            );
            if (this.model_form.name !== currentValue) {
                return new Promise(() => {});
            }

            if (res) {
                return Promise.reject(wording + "นี้มีอยู่แล้ว กรุณาใช้ชื่ออื่น");
            }
        } catch (error) {
            return Promise.reject("เกิดข้อผิดพลาดในการตรวจสอบข้อมูลซ้ำ");
        }
    },
    async validateTaxId(_rule, value) {
        const currentValue = value;
        const patternFixed = /^[0-9]+$/;
        if (value === this.old_tax_id) {
            return Promise.resolve();
        }
        if(!value){
            return Promise.reject('กรุณากรอกเลขประจำตัวผู้เสียภาษี');
        }
        if (/\s/.test(value)) {
            return Promise.reject('กรุณาลบช่องว่างในเลขประจำตัวผู้เสียภาษี');
        }
        if (!patternFixed.test(value)) {
            return Promise.reject('กรุณากรอกเฉพาะตัวเลขเท่านั้น');
        }
        if (value.length < 13 || value.length > 13) {
            return Promise.reject('กรุณากรอกเลขประจำตัวผู้เสียภาษีให้ครบ 13 หลัก');
        }
        try {
            const res = await SystemService.check_duplicate(
                this.model_type,
                `field=${_rule.field}&value=${value}&id=${this.action_type}`
            );
            if (this.model_form.tax_id !== currentValue) {
                return new Promise(() => {});
            }


            if (res) {
                return Promise.reject("เลขประจำตัวผู้เสียภาษีนี้มีอยู่ในระบบแล้ว");
            }
        } catch (error) {
            return Promise.reject("เกิดข้อผิดพลาดในการตรวจสอบข้อมูลซ้ำ");
        }
    },
    async validateCarRepairType(_rule, value) {
        const currentValue = value;
        const patternFixed = /^[0-9]+$/;
        const specialCharPattern = /[!@#$%^&*(),.?":{}|<>_\-+=/\\[\]~`]/;
        if (value == this.old_part_type) {
            return Promise.resolve();
        }
        if(!value){
            return Promise.reject('กรุณากรอกชื่อประเภท')
        }
        if (specialCharPattern.test(value) || patternFixed.test(value)) {
            return Promise.reject('มีอักขระที่ไม่อนุญาต กรุณาตรวจสอบ');
        }
        try {
            const res = await SystemService.check_duplicate(
                this.model_type,
                `field=${_rule.field}&value=${value}&id=${this.action_type}`
            );
            if (this.model_form.name !== currentValue) {
                return new Promise(() => {});
            }

            if (res) {
                return Promise.reject("ชื่อประเภทนี้มีอยู่่แล้ว กรุณาใช้ชื่ออื่น");
            }
        } catch (error) {
            return Promise.reject("เกิดข้อผิดพลาดในการตรวจสอบข้อมูลซ้ำ");
        }
    },
    async validateThaiPlateNo(_rule, value) {
        const patternFixed = /^[\u0E00-\u0E7F0-9]{2,3}-[\u0E00-\u0E7F0-9]{3,6}$/;
        const hasEnglish = /[a-zA-Z]/;
        const hasSpecial = /[!@#$%^&*(),.?":{}|<>_\+=/\\[\]~`]/;
        if(!value){
            return Promise.resolve()
        }
        if (hasEnglish.test(value) || hasSpecial.test(value)) {
            return Promise.reject('ห้ามใช้อักขระพิเศษ เช่น @,#,$ หรือภาษาอังกฤษ');
        }
        if(patternFixed.test(value)){
            return Promise.resolve()
        }
        return Promise.reject('รูปแบบทะเบียนรถไม่ถูกต้อง')
    },
    async validateCarTypeName(_rule, value) {
        const currentValue = value;
        const patternFixed = /^[a-zA-Zก-๙0-9\s\-]+$/;
        if (value == this.old_part_type) {
            return Promise.resolve();
        }
        if(!value){
            return Promise.reject('กรุณากรอกชื่อประเภท')
        }
        if (!patternFixed.test(value)) {
            return Promise.reject('มีอักขระที่ไม่อนุญาต กรุณาตรวจสอบ');
        }
        try {
            const res = await SystemService.check_duplicate(
                this.model_type,
                `field=${_rule.field}&value=${value}&id=${this.action_type}`
            );
            if (this.model_form.name !== currentValue) {
                return new Promise(() => {});
            }

            if (res) {
                return Promise.reject("ชื่อประเภทนี้มีอยู่่แล้ว กรุณาใช้ชื่ออื่น");
            }
        } catch (error) {
            return Promise.reject("เกิดข้อผิดพลาดในการตรวจสอบข้อมูลซ้ำ");
        }
    }
}

function convertToCSV(objArray) {
    var array = typeof objArray != 'object' ? JSON.parse(objArray) : objArray;
    var str = '';

    for (var i = 0; i < array.length; i++) {
        var line = '';
        for (var index in array[i]) {
            if (line != '') line += ','

            line += array[i][index];
        }

        str += line + '\r\n';
    }

    return str;
}

function CheckNumber(Number){
	var decimal = false;
	Number = Number.toString();						
	Number = Number.replace (/ |,|บาท|฿/gi,'');  		
	for (var i = 0; i < Number.length; i++)
	{
		if(Number[i] =='.'){
			decimal = true;
		}
	}
	if(decimal == false){
		Number = Number+'.00';
	}
	return Number
}